import React from 'react';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

class BrandList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setClass: props.showMenu ? 'open' : 'closed'
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showMenu != nextProps.showMenu) {
      this.setState({
        setClass: nextProps.showMenu ? 'open' : 'closed'
      });
    }
  }

  setBrand = e => {
    this.setState({
      setClass: 'closed'
    });
    this.props.setBrand(e.target.id);
  };

  render() {
    let { setClass } = this.state;
    return (
      <div className={`brands-container ${setClass}`}>
        <p className="select-brand-txt disabled">Select a brand</p>
        <ul
          onClick={event => {
            const { code: prodCode = '', name = '' } = this.props.productData || {};
            const luxe = this.props.newDesignLuxe;
            gtmEventPush({
              event: 'size_chart_interaction',
              event_category: 'size chart interactions',
              event_action: 'brand comparision',
              event_label: `${event.target.id.split('_')[0]}`,
              page_type: 'product page',
              product_name: name,
              product_id: prodCode,
              store_type: luxe ? 'luxe' : 'ajio'
            });

            // Segment event push
            segmentEventPush({
              event: 'Size Chart Interactions',
              event_category: 'size chart interactions',
              event_action: 'brand comparision',
              event_label: `${event.target.id?.split('_')[0] || ''}`,
              // page_type: 'product page',
              inch_or_cm_flag:'',
              interaction_description: `${event.target.id?.split('_')[0] || ''}`,
              products:[{
                product_name: name,
                product_id: prodCode,
              }],            
              store_type: luxe ? 'luxe' : 'ajio',
              screen_name: 'Brand List',
              size_selected_in_radio:'',
            });
            this.setBrand(event);
          }}
        >
          {/* <li className="disabled">Select a brand</li> */}
          {this.props.brands.map((item, idx) => (
            <li key={idx} id={item}>
              {/* <input id={idx} type="radio" value={item}/> */}
              {item.split('_')[0]}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default BrandList;
